
import React, { useState } from 'react'
import { useForm,  } from 'react-hook-form';
import {  useTranslation } from 'react-multi-lang'
import { BarChart } from './parials/BarChart'
import { PeiCahrt } from './parials/PeiChart'
import SmallCard from './parials/SmallCard'
import { useShared } from '../../hooks/useShared'
import APDate from '../../components/fields/APDate'
import Tariffs from '../tariff/Tariffs'
import ConnectionTester from '../../components/partials/ConnectionTester';



export default function Dashboard() {
  const { register,  watch, control, formState: { errors },  setValue,  } = useForm({});
  const { http, com, navigate, auth } = useShared()
  const [counts, setCounts] = useState([])
  const [value1, setValue1] = useState()

  const getDashBoardCounts = (data) => {
    http.post("api/dashboards", data).then(res => {
      console.log(res);
      if (res.data.success) {
        console.log(res.data);
        setCounts(res?.data?.data?.counts)
      }
    })
  }
  const t = useTranslation()
  React.useEffect(() => {
    getDashBoardCounts()
  }, [])

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      console.log(value, name, type)
      const arr = value.from_date?.split("/");
      const lastDate = arr[0]+"/"+arr[1]+"/29"
    

      getDashBoardCounts({ from_date: com.dateConvert(value.from_date), to_date:com.dateConvert(lastDate), year_date: com.dateConvert(value.year_date) })
    }

    )
    return () => subscription.unsubscribe()
  }, [watch])


  const gotPage = (which) => {
    navigate(which)
  }

  return (
    <div>
  
      <div className="flex justify-end bg-green-100/50 rounded-md mt-2" style={{ direction: 'ltr' }}>
        <APDate v={{ register, errors, control, setValue, data: { label: '', name: 'from_date', type: 'pdate', onlyMonth: true, render: true } }} />
      </div>

      <div className='grid md:grid-cols-3 gap-2 gap-x-6 mt-4'>
        <SmallCard v={{ name: `تعرفه‌`, icon: { name: "stats-chart-outline", className: 'bg-blue-500/20 !text-blue-600 ' }, onclick: () => gotPage('/db/tariffs/0'), amount: counts?.tariffs?.total, persantage: counts?.tariffs?.today }} />
        <SmallCard v={{ name: `اينوايس‌`, icon: { name: "bar-chart-outline", className: 'bg-orange-500/20 !text-orange-600 ' }, onclick: () => gotPage('/db/invoices/0'), amount: counts?.invoices?.total, persantage: counts?.invoices?.today }} />
        <SmallCard v={{ name: `مکتوب‌`, icon: { name: "pie-chart-outline", className: 'bg-pink-500/20 !text-pink-600 ' }, onclick: () => gotPage('/db/export_duty_letters/0'), amount: counts?.letters?.total, persantage: counts?.letters?.today }} />
       
       
        {!auth.hasRole([4]) &&<>
         <SmallCard v={{ name: `کاریران`, icon: { name: "person-outline", className: 'bg-gradient-to-br from-pink-500 to-purple-500' }, onclick: () => gotPage('/db/users/usrs'), amount: counts?.users?.total, persantage: counts?.users?.today }} />
        <SmallCard v={{ name: `شرکت `, icon: { name: "business-outline", className: 'bg-light-green-100 !text-green-600 ' }, onclick: () => gotPage('/db/companies'), amount: counts?.companies?.total, persantage: counts?.companies?.today }} />
        <SmallCard v={{ name: `کارمندان `, icon: { name: "people-outline", className: 'bg-light-blue-100 !text-blue-600 ' }, onclick: () => gotPage('/db/users/employees/0'), amount: counts?.employees?.total, persantage: counts?.employees?.today }} />
        </>  }


      </div>

      {auth.hasRole([4]) && <div className='mt-10'>
        <Tariffs />
      </div>}



      {!auth.hasRole([4]) && <div className='grid md:grid-cols-2 gap-2 gap-x-6 mt-4' style={{ direction: 'ltr' }}>
        {counts?.expensesAndIncomes && <BarChart v={{ className: 'w-[100%] ', data: counts?.expensesAndIncomes, register, errors, control, setValue }} />}
        {counts?.getExportRentalsAndMembershipCardIncones &&
          <PeiCahrt v={{ className: 'w-[100%] h-[85%] mb-5 py-5', data: counts?.getExportRentalsAndMembershipCardIncones, }} />}
      </div>}


    </div>
  )
}
